import { makeAutoObservable, runInAction, toJS } from "mobx";
import { openApi } from "../../../helpers/request";
import { FormEvent } from "react";
import { notification } from "antd";
import i from "../../../translations/i";
import { __cpl } from "../../catalog/custom_product_lists/__cpl";
import __select from "../../../helpers/select_entity/__select.controller";

class DiscountController {

  pagination = {
    total: 0,
    page: 1,
    limit: 10
  }

  list: any[] = []

  item: any = {
    id: 0,
    name: '',
    enabled: true,
    amount: 0,
    measurement: 0,
    purpose: null,
    id_crm: null,
    apply_old_price: true,
    gifts_merge: false,
    description: null,
    products_active: [],
    products_not_active: [],
    min_cart: null,
    how_many_items_cart: 2,
    how_many_items_gift: 1,
    price: null,
    cyclical: false,
    schedule: [],
    periods: [],
    levels: [],
    prohibit_write_off: false,
    disable_accrual: false,
    birthday: false,
    birthday_limit: null,
    warehouses: [],
    platforms: []
  }

  data: any = {
    warehouses: []
  }

  modalOpened = false
  modalKey = ''

  modalGiftOpened = false
  modalGiftIndex = 0

  levelsRenderKey = 0



  constructor() {
    makeAutoObservable(this)
  }

  getList() {
    openApi('get', '/discounts')
      .then(result => {
        console.log(result.data)
        this.list = result.data
      })
  }

  getOne(id: any) {
    if(id > 0)
      openApi('get', `/discounts/${id}?with[]=schedule&with[]=periods&with[]=products_active&with[]=products_not_active&with[]=levels&with[]=warehouses&with[]=platforms`)
        .then(result => {
          console.log(result.data)
          this.item = result.data
        })
        .catch(error => console.log(error.response))

    openApi('get', `/data_data`)
      .then(result => {
        this.data = result.data
      })
      .catch(error => console.log(error.response))
  }

  delete(id: any) {
    if(window.confirm(i.t('def:confirms.delete')))
      openApi('delete', `/discounts/${id}`)
        .then(result => {
          this.getList()
        })
        .catch(error => {

        })
  }

  save(e: FormEvent) {
    e.preventDefault()

    const data = new FormData()
    data.append('name', this.item.name)
    data.append('enabled', `${+ this.item.enabled}`)
    data.append('gifts_merge', `${+ this.item.gifts_merge}`)
    data.append('amount', `${this.item.amount}`)
    data.append('measurement', `${this.item.measurement}`)
    if(this.item.min_cart) data.append('min_cart', `${+ this.item.min_cart}`)
    if(this.item.purpose) data.append('purpose', this.item.purpose)
    if(this.item.id_crm) data.append('id_crm', this.item.id_crm)
    if(this.item.description) data.append('description', this.item.description)

    if(this.item.how_many_items_cart) data.append('how_many_items_cart', this.item.how_many_items_cart)
    if(this.item.how_many_items_gift) data.append('how_many_items_gift', this.item.how_many_items_gift)
    data.append('cyclical', `${+ this.item.cyclical}`)
    if(this.item.price) data.append('price', this.item.price)

    data.append(`sync_deps`, '1')

    data.append('apply_old_price', `${+ this.item.apply_old_price}`)
    data.append('prohibit_write_off', `${+ this.item.prohibit_write_off}`)
    data.append('disable_accrual', `${+ this.item.disable_accrual}`)
    data.append('birthday', `${+ this.item.birthday}`)
    if(this.item.birthday_limit !== null && this.item.birthday_limit !== undefined) data.append('birthday_limit', `${+ this.item.birthday_limit}`)

    if(this.item.products_active.length > 0) {
      this.item.products_active.map((el: any, index: number) => {
        data.append(`products_active[${index}]`, `${el.list_id}`)
      })
    }

    if(this.item.products_not_active.length > 0) {
      this.item.products_not_active.map((el: any, index: number) => {
        data.append(`products_not_active[${index}]`, `${el.list_id}`)
      })
    }

    if(this.item.warehouses.length > 0) {
      this.item.warehouses.map((el: any, index: number) => {
        data.append(`warehouses[${index}]`, `${el.warehouse_id}`)
      })
    }

    if(this.item.platforms.length > 0) {
      this.item.platforms.map((el: any, index: number) => {
        data.append(`platforms[${index}]`, `${el.platform}`)
      })
    }

    if(this.item.schedule.length > 0) {
      this.item.schedule.map((el: any, index: number) => {
        data.append(`schedule[${index}][day]`, `${el.day}`)
        data.append(`schedule[${index}][time_start]`, `${el.time_start}`)
        data.append(`schedule[${index}][time_end]`, `${el.time_end}`)
      })
    }

    if(this.item.periods.length > 0) {
      this.item.periods.map((el: any, index: number) => {
        data.append(`periods[${index}][date_from]`, `${el.date_from}`)
        data.append(`periods[${index}][date_to]`, `${el.date_to}`)
        if(el.year)  data.append(`periods[${index}][year]`, `${el.year}`)
      })
    }

    this.item.levels.map((el: any, index: number) => {
      console.log(el.products)
      if(el.id && el.id > 0) data.append(`levels[${index}][id]`, `${el.id}`)
      if(el.label) data.append(`levels[${index}][label]`, el.label)
      data.append(`levels[${index}][sorting]`, `${el.sorting}`)
      data.append(`levels[${index}][min_cart]`, `${el.min_cart}`)
      data.append(`levels[${index}][is_select]`, el.is_select ? '1' : '0')

      if(el.select_count) data.append(`levels[${index}][select_count]`, `${+ el.select_count}`)

      el.products.map((el: any, _index: number) => {
        data.append(`levels[${index}][products][${_index}][id]`, `${el.product_id}`)
        data.append(`levels[${index}][products][${_index}][count]`, `${el.count}`)
        if(el.price) data.append(`levels[${index}][products][${_index}][price]`, `${+ el.price}`)
      })
    })

    openApi('post', `/discounts/${this.item.id}`, data)
      .then(result => {
        window.location.href = `/settings/discount`
      })
      .catch(error => {
        console.log(error.response)
        notification.error({
          message: i.t('def:errors.error'),
          description: error.response.data.data.message ?? 'error'
        })
      })
  }

  closeModal() {
    this.item[this.modalKey] = []
    __cpl.selectedLists.map((el: any) => this.item[this.modalKey].push({ list_id: el }))
    this.modalOpened = false
    this.modalKey = ''
  }

  closeGiftModal(index: number) {
    runInAction(() => {
      this.item.levels[index].products = this.item.levels[index].products.filter((el: any) => __select.select.value_array.includes(el.product_id))

      __select.select.value_array = []
      this.modalGiftOpened = false
    })
  }

  openModal(key: string) {
    this.modalKey = key
    __cpl.selectedLists = this.item[key].map((el: any) => el.list_id)
    this.modalOpened = true
  }

  openGiftModal(modalGiftIndex: number) {
    runInAction(() => {
      __select.setValueArray(this.item.levels[modalGiftIndex].products.map((product: any) => product.product_id))
    })
    runInAction(() => {
      this.modalGiftOpened = true
      this.modalGiftIndex = modalGiftIndex
    })
  }

  addPeriod() {
    this.item.periods.push({
      day: 1,
      date_from: '',
      date_to: '',
      year: null
    })
  }

  addDay() {
    this.item.schedule.push({
      day: 1,
      time_start: 0,
      time_end: 0
    })
  }

  deleteSchedule(index: number) {
    this.item.schedule.splice(index, 1)
  }

  deletePeriod(index: number) {
    this.item.periods.splice(index, 1)
  }

  deleteProductList(key: 'products_active' | 'products_not_active', index: number) {
    this.item[key].splice(index, 1)
  }

  addLevel() {
    this.item.levels.push({
      sorting: 0,
      min_cart: 0,
      label: null,
      products: []
    })
    __select.setValueArray([])
  }

  deleteLevel(index: number) {
    this.item.levels.splice(index, 1)
  }

  addProductToLevel(index: number, product: any) {
    if(!this.item.levels[index].products.find((el: any) => el.product_id === product.id))
      this.item.levels[index].products.push({
        product_id: product.id,
        count: 1,
        product: product
      })
  }

  deleteProductFromLevel(indexLevel: number, indexProduct: number) {
    this.item.levels[indexLevel].products.splice(indexProduct, 1)
  }

  isValidDayMonth(value?: string | null): boolean {
    if (!value) return true; // nullable допустимо

    const match = value.match(/^(\d{2})\.(\d{2})$/);
    if (!match) return false;

    const day = Number(match[1]);
    const month = Number(match[2]);

    if (month < 1 || month > 12) return false;

    const daysInMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return day >= 1 && day <= daysInMonth[month - 1];
  }

  setItemLevelsIndexProductsCount(index: number, product_index: number, value: any) {
    console.log(this.item.levels[index].products[product_index])
    this.item.levels[index].products[product_index].count = value
  }

  setItemLevelsIndexProductsPrice(index: number, product_index: number, value: any) {
    this.refreshLevels()
    this.item.levels[index].products[product_index].price = value
  }

  refreshLevels() {
    this.levelsRenderKey += 1
  }

}

export default new DiscountController()